import { createSlice } from "@reduxjs/toolkit"

const workflow = createSlice({
  name: "workflow",
  initialState: {
    hasUnsavedChanges: false,
    saveButtonClicked: false,
    isSaving: false,
  },
  reducers: {
    updateWorkflowHasChanged(state, action) {
      state.hasUnsavedChanges = action.payload
    },
    updateSaveButtonClicked(state, action) {
      state.saveButtonClicked = action.payload
    },
    updateIsSaving(state, action) {
      state.isSaving = action.payload
    },
  },
})

export default workflow.reducer

const selectSlice = (state) => state.workflow

export const selectHasUnsavedChanges = (state) =>
  selectSlice(state).hasUnsavedChanges
export const selectSaveButtonClicked = (state) =>
  selectSlice(state).saveButtonClicked
export const selectIsSaving = (state) => selectSlice(state).isSaving

export const {
  updateWorkflowHasChanged,
  updateSaveButtonClicked,
  updateIsSaving,
} = workflow.actions
